export { SearchSuggestionsList } from './SearchSuggestionsList';
